'use client';

import { ContentLink } from '../lib/content-link';
import { CitationListAccordion } from './citation-list-accordion';
import { useCitationContext } from './context';

// Same treatment as body links (nodes/link.tsx).
const LINK_CLASS = 'text-secondary-foreground no-underline hover:underline';

export function CitationList({ summary = 'Articles Sources' }: { summary?: string }) {
  const { citations } = useCitationContext();

  if (!citations || citations.length === 0) return null;

  return (
    <CitationListAccordion summary={summary}>
      <div className="flex flex-col gap-2">
        <p>
          NerdWallet writers are subject matter authorities who use primary, trustworthy sources to
          inform their work, including peer-reviewed studies, government websites, academic research
          and interviews with industry experts. All content is fact-checked for accuracy, timeliness
          and relevance. You can learn more about NerdWallet&apos;s high standards for journalism by
          reading our{' '}
          <ContentLink
            className={LINK_CLASS}
            href="https://www.nerdwallet.com/l/nerdwallet-editorial-guidelines"
            target="_blank"
          >
            editorial guidelines
          </ContentLink>
          .
        </p>
        <ul>
          {citations.map(citation => {
            if (!citation.citationNumber) return null;

            return (
              <li
                className="flex items-start pt-2"
                id={`citation-${citation.id}`}
                key={citation.id}
              >
                <a
                  className="w-11 shrink-0 pl-2"
                  href={`#citation-ref-${citation.id}`}
                  onClick={event => {
                    event.preventDefault();
                    window.history.pushState(null, '', `#citation-ref-${citation.id}`);
                    document.getElementById(`citation-ref-${citation.id}`)?.scrollIntoView({
                      behavior: 'instant',
                      block: 'start',
                    });
                  }}
                >
                  {citation.citationNumber}.
                </a>
                <span>
                  {citation.publication}.{' '}
                  {typeof citation.url === 'string' ? (
                    <ContentLink className={LINK_CLASS} href={citation.url} target="_blank">
                      {citation.title}
                    </ContentLink>
                  ) : (
                    citation.title
                  )}
                  .{citation.accessDateFormatted ? ` ${citation.accessDateFormatted}` : null}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </CitationListAccordion>
  );
}
